<template>
  <label
    v-if="showDropdown"
    :for="`color-dropdown-${id}`"
    class="label"
    :class="{ 'updated-label' : isSpacingExpEnabledForMcom }"
  >
    Color:
  </label>
  <span
    v-else
  >
    <span
      class="label"
      :class="{ 'updated-label' : isSpacingExpEnabledForMcom }"
    >{{ colorLabel }}:</span>
    <span
      class="margin-left-xxxs"
      :class="[isMcom ? 'label' : 'medium', { 'updated-label': isSpacingExpEnabledForMcom }]"
    >
      {{ selectedColorName }}
    </span>
  </span>
  <span
    v-if="qty > minColorsToDisplayCounter && !isSpacingEnabled"
    class="small color-qty"
  > {{ qty }} colors </span>
</template>

<script setup>
import { useBrand } from '@composables/useBrand';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  qty: {
    type: Number,
    required: true,
  },
  selectedColorName: {
    type: String,
    default: '',
  },
  showDropdown: {
    type: Boolean,
    default: false,
  },
  minColorsToDisplayCounter: {
    type: Number,
    default: 6,
  },
  colorLabel: {
    type: String,
    default: 'Color',
  },
  isSpacingEnabled: {
    type: Boolean,
    default: false,
  },
});

const { isMcom } = useBrand();

const isSpacingExpEnabledForMcom = isMcom && props.isSpacingEnabled;
</script>
<style lang="scss" scoped>
.margin-left-xxxs {
  margin-left: calc(map-get($grid-margin-gutters, 'small') / 4);
}
.color-qty {
  white-space: nowrap;
}

.updated-label {
  font-weight: 400;
  text-transform: inherit;
}
</style>
